export default "__VITE_ASSET__BmlxH5ra__"